import { sendGAEvent } from '@next/third-parties/google';
import { useCallback } from 'react';

export const useGA = () => {
  const trackGAEvent = useCallback(({ category, action, label, value, fields }: any) => {
    sendGAEvent('event', action, {
      event_category: category,
      event_label: label,
      value,
      ...fields, // Spread operator to include additional fields
    });
  }, []);

  const trackButtonClickEvent = useCallback(
    ({ name }: any) => {
      trackGAEvent({
        action: `${name}_button_click`,
        label: `${name} button click`,
      });
    },
    [trackGAEvent],
  );

  return {
    trackGAEvent,
    trackButtonClickEvent,
  };
};
